(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-blog"]) return;
  try {
    
  $(document).ready(function(){
    $('body').append('<div class="tribox"><a href="#" title="close" class="tri-btn-close">close</a><div class="tribox-container"></div></div>');

    $('[data-tribox]').click(function(){
      var x = $(this).attr('href');
      
      $('body').addClass('no-scroll');
      $('.tribox').addClass('open');

      setTimeout(function(){
         $('.tribox-container').append('<iframe src="'+x+'"></iframe>');
      },200);

      return false;
    })
      
      ;

    $('[data-tribox-img]').click(function(){
      var x = $(this).attr('href');
      
      $('body').addClass('no-scroll');
      $('.tribox').addClass('open');

      setTimeout(function(){
         $('.tribox-container').append('<img src="'+x+'">');
      },200);

      return false;
    });


    
    $('.tri-btn-close').click(function(){
    
      
      $('body').removeClass('no-scroll');
      $('.tribox').removeClass('open');

      setTimeout(function(){
         $('.tribox-container').html(' ');
      },200);

      return false;
    });
    
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
  $(document).ready(function(){

  

  $('.accordion-item').each(function(){
      var x = $(this).find('.accordion-content-wrapper');
      var y = $(this).find('.accordion-content-wrapper').height();
      $(this).find('.accordion-content-wrapper').css('height',y).addClass('closed');

      $(this).find('.accordion-title').click(function(){
          if($(this).siblings('.accordion-content-wrapper').hasClass('closed')){

            $('.accordion-content-wrapper').addClass('closed');
            $(this).siblings('.accordion-content-wrapper').removeClass('closed');
            
          } else {
            $(this).siblings('.accordion-content-wrapper').addClass('closed');
          }
      });
    
  });

  });


    
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tri-editorial"] && !Shopify.designMode) return;
  try {
    
  $(document).ready(function(){
    $('.tri-slider').bxSlider({
      controls: true,
      pager: true,
      adaptiveHeight: true,
      speed: 800,
      auto: true,
      wrapperClass: 'triarchy-image-slider'
      
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tri-responsibility"] && !Shopify.designMode) return;
  try {
    
  
$(document).ready(function(){

  var fiber = $('.tri-slider').bxSlider({
      controls: false,
      pager: false,
      adaptiveHeight: true,
      speed: 800,
      auto: false,
      mode: 'fade'
    });


    $('.accordion-item').each(function(){
      var x = $(this).find('.accordion-content-wrapper');
      var y = $(this).find('.accordion-content-wrapper').height();
      $(this).find('.accordion-content-wrapper').css('height',y).addClass('closed');

      $(this).find('.accordion-title').click(function(){
          var s = $(this).attr('data-slide');
          var t = parseInt(s);
          var p = t - 1;

          if($(this).siblings('.accordion-content-wrapper').hasClass('closed')){
            
            $('.accordion-content-wrapper').addClass('closed');
            $(this).siblings('.accordion-content-wrapper').removeClass('closed');
            
            fiber.goToSlide(p);
            
          } else {
            $(this).siblings('.accordion-content-wrapper').addClass('closed');
          }
      });
    
  });

    
    var fiber = $('.tri-slider-fiber').bxSlider({
      controls: false,
      pager: false,
      adaptiveHeight: true,
      speed: 400,
      auto: false,
      mode: 'fade'
    });


    
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tri-video"] && !Shopify.designMode) return;
  try {
    
  $(document).ready(function(){
    $('body').append('<div class="tribox"><a href="#" title="close" class="tri-btn-close">close</a><div class="tribox-container"></div></div>');

    $('[data-tribox]').click(function(){
      var x = $(this).attr('href');

      if($(window).width() > 991) {
        $('body').addClass('no-scroll');
      }
      
      $('.tribox').addClass('open');

      setTimeout(function(){
         $('.tribox-container').append('<video autoplay loop><source src="'+x+'" type="video/mp4"></video>');
      },200);

      return false;
    });

    $('.tri-btn-close').click(function(){


      if($(window).width() > 991) {
        $('body').removeClass('no-scroll');
      }
      
      $('.tribox').removeClass('open');

      setTimeout(function(){
         $('.tribox-container').html(' ');
      },200);

      return false;
    });
    
  });

  } catch(e) { console.error(e); }
})();
})();
